import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getSeoTitle } from '@/stores/slices/titleSlice';

function useTitle(title, set = true) {
	const location = useLocation();
	const seoTitle = useSelector(getSeoTitle);
	const timeoutRef = useRef(null);

	useEffect(() => {
		if (!set) return;

		const finalTitle = seoTitle || title;

		timeoutRef.current = setTimeout(() => {
			if (document.title === finalTitle) {
				console.warn(`=> abort title setup. reason: same data`);
				return;
			}
			document.title = finalTitle;

			let ogMeta = document.querySelector('meta[property="og:title"]');
			if (!ogMeta) {
				ogMeta = document.createElement('meta');
				ogMeta.setAttribute('property', 'og:title');
				document.head.appendChild(ogMeta);
			}
			ogMeta.setAttribute('content', finalTitle);
		}, 500);

		return () => {
			if (timeoutRef.current) {
				console.warn(`=> abort title setup. reason: new data`);
				clearTimeout(timeoutRef.current);
			}
		};
	}, [location, title, set, seoTitle]);
}

export default useTitle;
